// Keep successful steps when a later request fails, so retry resumes this deal.
export async function saveDealDraft(draft, progress, api) {
  if (!progress.dealId) {
    const deal = await api.createDeal(draft.deal)
    progress.dealId = deal.id
  }
  if (draft.company && !progress.companyLinked) {
    if (!progress.companyId) progress.companyId = (await api.createCompany(draft.company)).id
    await api.updateDeal(progress.dealId, { company_id: progress.companyId })
    progress.companyLinked = true
  }
  if (draft.lead && !progress.linked) {
    if (!progress.contactId) {
      const leadData = progress.companyId ? { ...draft.lead.data, company_id: progress.companyId } : draft.lead.data
      progress.contactId = draft.lead.id || (await api.createCrmContact(leadData)).id
    }
    await api.linkDealContact(progress.dealId, { contactId: progress.contactId, isPrimary: true })
    progress.linked = true
  }
  progress.itemsSaved ??= 0
  while (progress.itemsSaved < draft.items.length) {
    await api.createDealItem(progress.dealId, draft.items[progress.itemsSaved])
    progress.itemsSaved++
  }
  return progress.dealId
}
